<script lang="ts" setup>
const { workspace } = useAuth()
const { hasTrialSubscription } = useSubscription()
</script>

<template>
  <aside
    class="hidden w-60 flex-col border-r border-gray-200 md:flex"
  >
    <AppNavigation class="flex-1 overflow-y-auto px-2.5 pb-2 pt-4" />

    <TrialAlert
      v-if="hasTrialSubscription"
      class="my-2.5"
    />

    <GracePeriodCard
      v-if="!!workspace?.attributes.retention_starts_at && !!workspace?.attributes.grace_starts_at"
      :grace-starts-at="workspace?.attributes.grace_starts_at"
      :grace-ends-at="workspace?.attributes.retention_starts_at"
      class="m-2.5"
    />
  </aside>
</template>
